<template>
    <div>
        <modal v-if="popup_open && popup_name === 'create_moodpost'" modal_name="create_moodpost" type="large" :title="translations['forum.create_moodpost']" icon="image">
            <template v-slot:modal-content>
                <validation-observer ref="modal-create_moodpost">
                    <validation-provider rules="required|image" name="image" v-slot="{validate, errors}">
                        <input ref="newPostImagePicker" class="hidden" type="file" accept=".jpg, .png, .jpeg, .gif, .bmp" @change="addImage($event); validate($event);">

                        <div class="moodpost-image-select hover-opacity" v-if="imageCount === 0 || uploading" @click="openImageUploader" id="error-moodpost-image-upload-wrapper" :class="{'tw-opacity-50': uploading}">
                            <div class="placehold-image">
                                <img class="cg-image" src="https://geokey.communitymaps.org.uk/media/themes/People_and_Society3.jpg.530x240_q85_crop.jpg">
                            </div>

                            <div class="absolute-content">
                                <p class="normal-text bold-text">{{ translations['fields.select'] }} {{ translations['fields.image'].toLowerCase() }}</p>
                            </div>
                            <span class="tw-text-gray-300 small-text tw-block tw-mt-2 tw-mb-4 tw-italic tw-text-left" v-text="translations['validation.dont_exceed_8_mb']"></span>
                        </div>
                        <div class="moodpost-image-select hover-opacity tw-mb-4" id="error-moodpost-image-upload-wrapper" v-else>
                            <img class="cg-image" :src="new_post_image_preview">
                        </div>

                        <span class="form-validation-error tw--mt-3 tw-mb-3" v-if="errors.length > 0">{{ errors[0] }}.</span>
                    </validation-provider>
                    <form-row>
                        <form-field>
                            <form-input v-model="new_post_title" :label="'Moodpost ' + translations['general.title'].toLowerCase()" rules="required" name="title" :placeholder="'Moodpost ' + translations['general.title'].toLowerCase()"></form-input>
                        </form-field>
                    </form-row>
                    <form-row>
                        <form-field>
                            <label class="form-label">Moodpost {{ translations['general.content'].toLowerCase() }}</label>
                            <huddle-editor-v2   v-model="new_post_content"
                                                type="textarea"
                                                :emojis="true"
                                                :close_emoji_picker_on_select="true"
                                                :mentions="true"
                                                :channelId="boardId"
                                                :placeholder="'Moodpost ' + translations['general.content'].toLowerCase()"
                                                rules="required|min:5"
                                                name="content">
                            </huddle-editor-v2>
                        </form-field>
                    </form-row>
                </validation-observer>
            </template>
            <template v-slot:modal-bottom>
                <div class="subtle-button slim" @click="closePopup">
                    {{ translations['fields.cancel'] }}
                </div>
                <div class="general-button btn-v2 slim" @click="submitNewMoodpost">
                    Create moodpost
                    <i class="far fa-check"></i>
                </div>
            </template>
        </modal>

        <masonry :cols="{default: 6, 1600: 5, 1450: 4, 1200: 3, 940: 2, 500: 1}" :gutter="15">
            <div class="moodboard-post card card-shadow" v-if="topic.attachments[0]" v-for="topic in orderedMoodfeed" @click="openMoodview(topic)" :key="topic.id">
                <div class="post-stats z-1">
                    <div class="stat comments secondary-c">
                        <template v-if="topic.comments_count">
                            <p class="normal-text secondary-c bold-text">{{ topic.comments_count }}</p>
                        </template>
                        <template v-else>
                            <p class="normal-text secondary-c bold-text">0</p>
                        </template>
                        <i class="far fa-comments small-text"></i>
                    </div>
                    <div class="stat likes secondary-c">
                        <template v-if="topic.likes_count">
                            <p class="normal-text secondary-c bold-text">{{ topic.likes_count }}</p>
                        </template>
                        <template v-else>
                            <p class="normal-text secondary-c bold-text">0</p>
                        </template>
                        <i class="far fa-thumbs-up small-text"></i>
                    </div>
                </div>
                <div class="card-top top-image">
                    <img v-if="showPreviewImage(topic)" :src="showPreviewImage(topic)" alt="">
                </div>
                <div class="card-inner flex">
                    <div class="flex-1 flex-no-padding">
                        <div class="profile-icon-l">
                            <a :href="'/profile/' + topic.user().username">
                                <img :src="topic.user().avatar" onerror="this.src='/img/avatar.png'" />
                            </a>
                        </div>
                    </div>
                    <div class="flex-5 flex-no-padding">
                        <div class="moodboard-post-content">
                            <div class="post-content light-text small-title-text secondary-c bold-text" v-html="topic.title"></div>
                            <a class="hover-opacity small-text light-text block" :href="'/profile/' + topic.user().username">
                                {{ topic.user().name }}
                            </a>
                            <div class="post-timestamp extra-light-text tiny-text">
                                {{ topic.created_at | getDateHumanFormat }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </masonry>

        <div class="spinner medium" v-if="loading || currentlyPaginating">
            <div class="spinner-wrapper">
                <div class="rotator">
                    <div class="inner-spin"></div>
                    <div class="inner-spin"></div>
                </div>
            </div>
        </div>
        <div class="floating-action-button secondary-c-bg secondary-c-contrast hover-opacity" @click="openCreateMoodpostPopup" v-if="!restricted || user.isModerator">
            <i class="far fa-plus"></i>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import axios from 'axios'
    import moment from 'moment'
    import orderBy from 'lodash.orderby';

    let pluralize = require('pluralize')

    import Global from '../mixins/Global.js'
    import Modal from '../mixins/v2/Modal';
    import loadImage from 'blueimp-load-image';

    export default {
        mixins: [Global, Modal],
        name: 'MoodFeed',

      props: {
        restricted: {
          default: false,
        }
      },

        data() {
            return {
                loading: true,
                failed: false,
                pagination: false,
                currentlyPaginating: false,
                hashOpened: false,
                load_topic_by_hash_id: false,
                // variables for creating a new moodpost
                new_post_image_file: false,
                new_post_image_preview: false,
                new_post_title: '',
                new_post_content: '',
                uploadedImages: [],
                imageCount: 0,
                image_uuid: '',
                uploading: false,
                boardId,
            }
        },

        computed: {
            ...mapState([
                'moodviewOpen',
                'topics',
                'topics_ids',
                'modalData',
            ]),


            orderedMoodfeed() {
                let topics = this.topics;

                topics = orderBy(topics, ['newly_created', 'created_at'], ['desc', 'desc']);

				topics = topics.filter(topic => (topic.attachments.length > 0));

                return topics;
            }
        },

        methods: {
            showPreviewImage(topic) {
                // search in topic attachments where object key id exists (otherwise it's a video and preview won't load) and return the source
                const attachment =  topic.attachments.find((attachment) => attachment.id);

                if (attachment) {
                    return attachment.source.substring(0, 4) === 'data' ? attachment.source : attachment.source + '?size=medium';
                } else {
                    return false;
                }
            },

            openCreateMoodpostPopup() {
                // clear uploadedImages array and reset upload fields
                // because as de input file is empty after re-opening the model, so this validates to false
                // (but visually it seems filled because of the uploadedImages)
                this.uploadedImages = [];
                this.new_post_image_preview = false;
                this.imageCount = 0;

                this.new_post_title= '',
                this.new_post_content= '',
                this.openPopup('create_moodpost');
            },

            handleScroll () {
                //see if scrolled near bottom
                if ((window.innerHeight + window.pageYOffset + 1500) >= document.body.offsetHeight && this.topics.length > 0 && !this.failed) {
                    this.paginate();
                }
            },

            openMoodview(topic) {
                this.$store.commit('setMoodTopic', topic);
                this.$store.commit('setMoodview', true);
            },

            getFeedTopics(paginate, load_single_topic = false) {
                //if full load and not pagination
                if(!paginate) {
                    //start the loading spinner
                    this.loading = true;

                    //reset the feed
                    this.$store.commit('resetFeed');
                }

                let url = '/api/v3/topics';

                let params = new URLSearchParams();

                if(!load_single_topic) {
                    params.append('board_id', boardId);

                    //if paginating, get the next page of topics
                    if(paginate) {
                        params.append('page', this.pagination.current_page+1);
                    }
                } else {
                    url += '/' + this.load_topic_by_hash_id;
                }

                let request = {
                    params: params
                };

                //request feed data
                axios.get(url, request)
                    .then((response) => {

                        //feed data
                        var topics = response.data;

                        var data_models = [
                            {
                                model: 'Topic',
                                source: 'data',
                                nested_models: [
                                    {
                                        model: 'User',
                                        source: 'user',
                                        storage: 'users',
                                        child_key: 'user_id'
                                    },
                                    {
                                        model: 'Like',
                                        source: 'liked_by',
                                        storage: 'likes',
                                        parent_key: 'conversation_id',
                                    }
                                ]
                            }
                        ];

                        ActiveDataStore.activeDataSetup(data_models, topics);

                        //pagination data
                        if(response.data.meta) {
                            this.pagination = response.data.meta.pagination;
                        }

                        this.loading = false;

                        this.currentlyPaginating = false;
                        this.handleScroll();
                    }, error => {
                        this.failed = true;
                        this.loading = false;
                        this.currentlyPaginating = false;
                    });

            },

            paginate() {
                let pagination = this.pagination;

                //if there are more topics that can be loaded
                if(pagination.current_page < pagination.total_pages && !this.currentlyPaginating) {
                    this.currentlyPaginating = true;
                    this.getFeedTopics(true);
                }
            },

            //methods for creating a new moodpost are below

            openImageUploader() {
                if(this.imageCount === 0) {
                    this.$refs.newPostImagePicker.click();
                }
            },

            addImage(event) {
                let self = this;

                this.uploadedImages.push(event.target.files[0]);

                //generate the uuid for the image
                let uuid = this.generateUUID();

                this.image_uuid = uuid;

                //prepare image data
                let image_data = {
                    file: event.target.files[0],
                    name: event.target.files[0].name,
                    uuid: uuid,
                };

                let formData = new FormData();

                for ( var key in image_data ) {
                    formData.append(key, image_data[key]);
                }

                //save image in backend
                this.uploading = true;

                axios.post('/uploader', formData).then(() => {
                    this.uploading = false;

                    loadImage.parseMetaData(event.target.files[0], function(data) {
                        //default image orientation
                        let orientation = 0;

                        //if exif data available, update orientation
                        if (data.exif) {
                            orientation = data.exif.get('Orientation');
                        }

                        loadImage(
                            event.target.files[0],
                            function(canvas) {
                                //add the parsed image with correct orientation to the previews
                                self.new_post_image_file = event.target.files[0];
                                self.new_post_image_preview = canvas.toDataURL('image/jpeg');
                            }, {
                                //should be set to canvas : true to activate auto fix orientation
                                canvas: true,
                                orientation: orientation
                            }
                        );
                    });

                    this.imageCount++;
                }).catch((err) => {
                    this.uploading = false;
                    alert('Something went wrong during the upload. Please make sure your image does not exceed the limit of 8MB and that the filetype is of JPG or PNG.');
                });
            },

            submitNewMoodpost() {
                this.validateModal().then(() => {
                    //prepare data
                    let data = {
                        'title': this.new_post_title,
                        'content': this.new_post_content,
                        'channel_id': boardId,
                        'upload_uuids': [this.image_uuid],
                        'new_post_image_file': this.new_post_image_file,
                        'new_post_image_preview': this.new_post_image_preview
                    };

                    this.$store.dispatch(
                        {
                            type: 'submitNewMoodpost',
                            data: {
                                data: data
                            }
                        }
                    ).then(() => {
                        this.new_post_title = '';
                        this.new_post_content = '';
                        this.new_post_image_file = false;
                        this.new_post_image_preview = false;
                        this.imageCount = 0;
                        this.uploadedImages = [];
                        this.image_uuid = '';
                    }).catch(() => {
                        alert('Something went wrong. Please check whether all fields are filled in and if possible attachments do not exceed the size limit of 8MB.');
                    });

                    this.closePopup();
                }).catch(() => {});
            },
        },

        created() {
            //listen to scroll
            window.addEventListener('scroll', this.handleScroll);
        },

        mounted() {
            this.getFeedTopics();
        },

        destroyed() {
            //remove scroll listener
            window.removeEventListener('scroll', this.handleScroll);
        },

        watch: {
            topics: function() {
                if(!this.moodviewOpen && !this.hashOpened) {
                    let hash = window.location.hash;

                    if(hash !== '') {
                        hash = hash.substr(1);
                        hash = decodeURI(hash);
                        let id = hash.substr(8);

                        id = parseInt(id);

                        if(this.topics_ids.includes(id)) {
                            let topic = this.$store.getters.getTopicById(id);

                            if(topic) {
                                this.openMoodview(topic[0]);
                                this.hashOpened = true;
                            }
                        } else if(!this.load_topic_by_hash_id) {
                            this.load_topic_by_hash_id = id;
                            this.getFeedTopics(true, true);
                        }
                    } else {
                        this.hashOpened = true;
                    }
                }
            }
        },

        filters: {
            getDateHumanFormat: function (date) {
                return moment(date).fromNow();
            }
        }
    }
</script>

<style lang="scss">
    .create_moodpost-modal {
        .image-previews {
            margin-top: 10px;

            .image-preview {
                display: inline-block;
                margin-right: 10px;

                img {
                    height: 130px;
                    width: 130px;
                    padding: 10px;
                    border-radius: 3px;
                    background: rgba(0, 0, 0, 0.3);
                    transition: border 0.3s ease-in-out;
                    border: 2px solid transparent;

                    &:hover {
                        cursor: pointer;
                        border: 2px solid #ff9999;
                    }
                }
            }
        }

        .moodpost-image-select {
            @apply tw-relative tw-text-center;
            border-radius: 10px;

            .placehold-image {
                @apply tw-overflow-hidden tw-rounded-lg tw-opacity-50;
                height: 183px;

                img {
                    @apply tw-w-full;
                }
            }

            img {
                @apply tw-max-w-full tw-rounded-lg;
            }

            .absolute-content {
                @apply tw-absolute tw-left-0 tw-right-0 tw-uppercase;
                top: 59px;

                p {
                    font-size: 30px;
                }
            }
        }
    }
</style>
